<template>
  <div
    class="w-full border border-black/8 shdw flex items-center justify-between pl-[22px] pr-4 rounded-xl px-4 py-3 cursor-pointer font-medium"
    :class="classes"
    @click="handleClick"
  >
    <div
      class="font-secondary text-[14px] leading-[24px] text-gray-900 flex items-center"
    >
      <div class="text-[24px] mr-[15px]">{{ props.icon }}</div>
      <slot />
    </div>

    <Checkbox v-if="showCheckbox" v-model="selected" @click.stop />
  </div>
</template>

<script setup lang="ts">
import { Checkbox } from '@dacr/ui'
import { computed } from 'vue'

const props = defineProps<{
  modelValue: string | string[]
  icon: string
  value: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | string[]): void
}>()

const selected = computed({
  get() {
    return typeof props.modelValue === 'string'
      ? props.modelValue === props.value
      : props.modelValue.includes(props.value)
  },
  set() {
    handleClick()
  },
})

const showCheckbox = computed(
  () => selected.value || typeof props.modelValue !== 'string'
)

const classes = computed(() => ({
  'border-green-500 bg-green-200/20 outline outline-green-500': selected.value,
  'hover:bg-gray-200/13': !selected.value,
}))

const handleClick = () => {
  if (typeof props.modelValue === 'string') {
    emit('update:modelValue', props.value)
  } else {
    let newValue = props.modelValue.slice()

    if (newValue.includes(props.value)) {
      newValue = newValue.filter((val) => val !== props.value)
    } else {
      newValue.push(props.value)
    }

    emit('update:modelValue', newValue)
  }
}
</script>

<style scoped>
.shdw {
  box-shadow:
    0 4px 18px 0 rgba(0, 0, 0, 0.04),
    0 0.8px 2.93px 0 rgba(0, 0, 0, 0.02);
}
</style>
